import { useCharacterFormLogic, numberString } from "./useCharacterFormLogic";

// Re-export numberString for backward compatibility
export { numberString };

export const useCharacterSubmit = () => {
  // Use the consolidated hook with 'character' mode
  const result = useCharacterFormLogic("character");

  // Determine readiness based on the hook's state
  const isReady =
    Array.from(result.characterNames.values()).every(
      (name) => name.trim().length > 0
    ) && result.characterNames.size === result.characters.length;

  // Return the exact same interface as before for backward compatibility
  return {
    // Data
    sortedCharacters: result.characters,
    isSolo: result.isSolo,
    settings: result.settings,
    characterNames: result.characterNames,
    characterMaturities: result.characterMaturities,

    // Computed values
    isReady,
    subHeaders: result.subHeaders,
    submitText: result.submitText,
    titles: result.titles,

    // Actions
    handleChange: result.handleChange,
    handleMature: result.handleMature,
    createPlayerAction: result.createPlayerAction,
  };
};
